import {useTranslation} from 'react-i18next';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/form';
import {ToggleGroup, ToggleGroupItem} from '@/components/ui/toggle-group';
import residentGroups from '@/translation/residentGroups';

import type {ExportOptionsFieldsProps} from '../../types/exportTypes';
import type {ResidentsOptions} from '../../utils/definitions/residentsExport';
import {RESIDENT_GROUPS} from '../../utils/definitions/residentsExport';

const ResidentGroupOptionsFields = ({
  form,
}: ExportOptionsFieldsProps<ResidentsOptions>) => {
  const {t} = useTranslation();

  return (
    <FormField
      control={form.control}
      name="options.group"
      render={({field}) => (
        <FormItem>
          <FormLabel>{t('Residents')}</FormLabel>
          <FormControl>
            <ToggleGroup
              type="single"
              value={field.value}
              onValueChange={value => {
                if (value) field.onChange(value);
              }}
            >
              {RESIDENT_GROUPS.map(group => (
                <ToggleGroupItem key={group} value={group}>
                  {residentGroups[group]}
                </ToggleGroupItem>
              ))}
            </ToggleGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};

export default ResidentGroupOptionsFields;
